import React, { useEffect, Fragment } from "react";
import ImageGalleryT from "../../components/ImageGalleyT";
import Slider from "../../components/Slider";

import { useDispatch }              from "react-redux";
import { 
    setCategoriasAction
}                                               from "../../actions/searchActions";

import { 
    ShareButton as ShareIcon,
    //ShareLike as SLike, 
    ShareFacebook as SFacebook, 
    ShareTwitter as STwitter
}   from "../../components/Icons";
import HeaderExtended from "../../components/layout/HeaderExtended";

import { 
    getCategoriasR as getCats,
    getDetalleArticuloR as getDetalleArt,
    convertToPrice as getPrecio,
    decodeToNumber as dToNumber,
    jsonDeserialize
}   from "../../API/request";
import Loading from "../../components/Loading";
import Legal from "../../components/Legal";
import BtnSubir from "../../components/BtnSubir";


const Details = (props) => {
    const dispatch = useDispatch();
    const [showLoading, setShowLoading] = React.useState(true);
    const [showSocialBtns, setShowVersion] = React.useState("");
    const [detalleArticulo, setDetalleArticulo] = React.useState(null);
    const [listadoCategorias, setListadoCategorias] = React.useState(null);
    const [collectionDetalle,setCollectionDetalle] = React.useState("");
    const [collectionDetalleCategoria,setCollectionDetalleCategoria] = React.useState("");
    const [collectionDetalleTallas,setCollectionDetalleTallas] = React.useState([]);

    //const collectionName = props.match.params.category;
    const articleId = props.match.params.article;
    const showPrice = process.env.REACT_APP_SHOW_PRICE  === 'false' ? false : true;
    const showStock = process.env.REACT_APP_SHOW_STOCK  === 'false' ? false : true;
    const showTalla = process.env.REACT_APP_SHOW_TALLA  === 'false' ? false : true;

    const dateMonthYear = new Date().toLocaleString('es-MX',{month:'long', year:'numeric'});

    useEffect(() => {
        window.scrollTo(0, 0)
        setShowLoading(true);
        setDetalleArticulo(null);
        setCollectionDetalle(null);
        setCollectionDetalleCategoria(null);
        setListadoCategorias(null);


        getDetalleArt(dToNumber(articleId))
            .then( ( responseDetalleArticulo ) => {
                let detArticulo = jsonDeserialize(responseDetalleArticulo.data.data);
                //console.log(detArticulo);
                setDetalleArticulo(detArticulo);
                //console.log(detArticulo.catDetails);

                setCollectionDetalleCategoria(detArticulo.catDetails.categoria);
                setCollectionDetalle(detArticulo.catDetails.articulos.data);


                setCollectionDetalleTallas(detArticulo.catDetails.articulos.data.filter( (item => item.nombre === detArticulo.Nombre )))
                //console.log(detArticulo.catDetails.articulos.data.filter( (item => item.nombre === detArticulo.Nombre )));

                document.title = "Article - " + detArticulo.Nombre;

                getCats()
                    .then( ( responseCategorias ) => {
                        let cats = jsonDeserialize(responseCategorias.data.data).data;
                        setListadoCategorias(cats);
                        dispatch(setCategoriasAction(cats));
                        setShowLoading(false);
                        window.scrollTo(0, 0)
                    })
                    .catch((errorMessageGetMantenimiento)=>{
                        console.log("ERORR - En la petición")
                    });
                
            })
            .catch((errorMessageGetMantenimiento)=>{
                console.log("ERORR - En la petición")
            });
    }, [articleId,setShowLoading,setListadoCategorias,setCollectionDetalle,setDetalleArticulo,dispatch]);


    const showButtons = () =>{
        showSocialBtns === "" ?  setShowVersion("show") : setShowVersion("");
    }

    //const facebookLike = () => {
        //window.open("http://www.facebook.com/plugins/like.php?href=" + encodeURIComponent(document.URL) + "&amp");
        //showButtons();
    //}
    const facebookShare = () => {
        window.open("https://facebook.com/sharer/sharer.php?u=" + encodeURIComponent(document.URL), '_blank');
        showButtons();
    }
    const twitterShare = () => {
        window.open("https://twitter.com/intent/tweet?url="+ encodeURI(document.URL)+"&text="+document.title, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600');
        showButtons();
    }

    return (
        <Fragment>
            {
                showLoading
                ?   <Loading/>
                :   <>
                        <HeaderExtended
                            category={collectionDetalleCategoria}
                            menuType={false}
                            listado={listadoCategorias}
                            actual={collectionDetalleCategoria}
                        />

                        <div className="content secondary">
                            <div className="container">
                                <div className="row row-cols-1 row-cols-md-2 details">
                                    {
                                        detalleArticulo.Activo 
                                        ?   <>
                                                <div className="col details__image">
                                                    <ImageGalleryT
                                                        articuloNuevo={detalleArticulo.Nuevo}
                                                        imagesArticulo={detalleArticulo.imgs.data}
                                                    />
                                                </div>
                                                <div className="col details__info">
                                                    <div className="details__info--share">
                                                        <div className="details__info--share--button" onClick={() => showButtons()}>
                                                            <ShareIcon />
                                                        </div>
                                                        {/*<div className={"details__info--share--social " + showSocialBtns}  onClick={() => facebookLike()}>
                                                            <SLike />
                                                        </div>*/}
                                                        <div className={"details__info--share--social " + showSocialBtns} onClick={() => facebookShare()}>
                                                            <SFacebook />
                                                        </div>
                                                        <div className={"details__info--share--social " + showSocialBtns} onClick={() => twitterShare()}>
                                                            <STwitter />
                                                        </div>
                                                    </div>

                                                    <h1 className="o-1">{detalleArticulo.Nombre}</h1>
                                                    {
                                                        showPrice &&
                                                            <h4 className="o-2">{getPrecio(detalleArticulo.PrecioPublico)}</h4>
                                                    }

                                                    <span className="o-3">{"No. de Articulo: " + detalleArticulo.NumParte}</span>

                                                    {
                                                        showStock &&
                                                            <><br/><span className="o-3">{detalleArticulo.Stock !== 0 ? "Piezas disponibles: "+ detalleArticulo.Stock : "Sin inventario"}</span></>
                                                    }
                                                    {
                                                        showTalla &&
                                                            <p className="o-3 mb-0">{detalleArticulo["Tamaño"]}</p>
                                                    }
                                                    
                                                    <p className="o-4">{detalleArticulo.DescripcionLarga}</p>
                                                </div>
                                            </>
                                        :   <h2>Articulo no disponible</h2>
                                    }
                                </div>
                            </div>

                            <Legal
                                texto={"Para consultar la disponibilidad, los precios y oferta de los artículos Audi Collection, se recomienda acudir a tu Distribuidor Autorizado Audi dentro de la República Mexicana."}
                                txtBoton="Contacto"
                                urlBoton={process.env.REACT_APP_FORMULARIO_CONTACTO_PATH + articleId}
                            />

                            <div className="d-separator"></div>
                            {
                                collectionDetalleTallas.length > 1 
                                ?   <Slider
                                        title="Tallas disponibles"
                                        articulos={collectionDetalleTallas}
                                        showPrice={showPrice}
                                        showTallas={true}
                                    />
                                :   <Slider
                                        title="Más"
                                        articulos={collectionDetalle}
                                        showPrice={showPrice}
                                        showTallas={false}
                                    />
                            }
                        </div>
                        <BtnSubir />
                    </>
            }
        </Fragment>
    );
};

export default Details;
